let payInst = null;

export const getPayInst = (params, config, callback) => {
  payInst = null;
  // eslint-disable-next-line no-undef,camelcase
  payInst = new AddPaymentIframe({ params, config, callback });
  return payInst;
};
